import React from "react";

import createBaseRenderer from "./createBaseRenderer";

import { ZadostHistorieItem } from "./";

export default createBaseRenderer({
  name: "zadostHistorie",
  placeholderText: "23. března 17:18 Váš požadavek byl přijat.",
  content: ({ val }) => (
    <div className="b2b-ZadostHistorie">
      {val?.length
        ? val.map(item => <ZadostHistorieItem key={item.datum} val={item} />)
        : undefined}
    </div>
  )
});
